/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import {BolmateProductRow, BolmateSectionCard} from '../../../controls';

import {OverviewTopProduct} from '../../../../util/interfaces';

import {formatCurrency} from '../../../../util/utils';

import {OverviewSectionState} from '../useOverviewSection';

export default function TopProducts(props: OverviewSectionState<OverviewTopProduct>) {
    const {items, loading, loadingMore, error, hasMore, onLoadMore} = props;
    const {t} = useTranslation();

    function renderRow(product: OverviewTopProduct, index: number) {
        return (
            <BolmateProductRow
                key={index}
                imageUrl={product.image_url}
                imageBadge={`${product.quantity}x`}
                imageBadgeTitle={t('overview.topProducts.soldTooltip', '{{count}} verkocht', {
                    count: product.quantity
                })}
                title={product.title}
                titleHref={product.product_url}
                ean={product.ean}
                primaryStat={{label: t('overview.stat.revenue', 'Omzet'), value: formatCurrency(product.revenue)}}
                secondaryStat={{
                    value: `${t('overview.stat.profit', 'Winst')}: ${formatCurrency(product.profit)}`,
                    tone: product.profit >= 0 ? 'positive' : 'negative'
                }}
            />
        );
    }

    return (
        <BolmateSectionCard
            title={t('overview.sections.topProducts', 'Meest verkochte producten')}
            loading={loading}
            loadingMore={loadingMore}
            empty={!items.length}
            emptyLabel={t('overview.topProducts.empty', 'Nog geen verkopen in deze periode')}
            error={error ? t('overview.sectionError', 'Deze sectie kon niet geladen worden') : undefined}
            hasMore={hasMore}
            loadMoreLabel={t('overview.loadMore', 'Meer laden')}
            onLoadMore={onLoadMore}
        >
            {items.map(renderRow)}
        </BolmateSectionCard>
    );
}
